import BaseService from '../base';

class Certificate extends BaseService {}
export default new Certificate('certificates', 'Certificate');
